import { Box } from "@mui/material";
import { styled } from "@mui/system";
import bg from "../../assets/images/tickets-bg.webp";

export const StyledWrapper = styled(Box)(({ theme }) => ({
  position: "relative",
  backgroundColor: theme.palette.primary.main,
  overflow: "hidden",
  "&::before": {
    content: '""',
    position: "absolute",
    inset: 0,
    backgroundImage: `url(${bg})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center top",
    mixBlendMode: "multiply",
    pointerEvents: "none",
    zIndex: 0,
  },
  "&::after": {
    content: '""',
    position: "absolute",
    inset: 0,
    background:
      "linear-gradient(180deg, rgba(235,0,40,0) 0%, rgba(235,0,40,0) 25%, rgba(235,0,40,0.6) 55%, #EB0028 100%)",
    pointerEvents: "none",
    zIndex: 1,
  },
  ".overlay": {
    display: "none",
  },
  ".footer-container": {
    position: "relative",
    zIndex: 2,
    maxWidth: theme.breakpoints.values.lg,
    margin: "0 auto",
    padding: "0 24px",
    height: "100%",
  },
  ".mobile-black-container": {
    padding: "20px 24px",
    zIndex: 2,
    position: "relative",
  },
  ".menu-item-link": {
    textDecoration: "none",
  },
  ".menu-item-label": {
    fontFamily: "Inter",
    textDecoration: "none",
    fontSize: "12px",
    lineHeight: "16px",
    fontWeight: 500,
    color: "#fff",
    textAlign: "center",
  },
  ".copyright-box": {
    zIndex: 2,
    position: "relative",
    padding: "20px 16px",
    "& p": {
      fontFamily: "Inter",
      fontSize: "11px",
      lineHeight: "16px",
      textAlign: "center",
      color: "#fff",
    },
  },
}));

export default StyledWrapper;
